<template>
  <div class="grid-wrapper">
    <div class="uk-flex uk-flex-between">
      <h5 style="display: contents;">
        Temperaturas de transporte y Almacenamiento recomendados
      </h5>
      <div
        style="cursor: pointer;"
        @click="downloadFile"
      >
        <p style="display: contents;">
          Descargar Excel
        </p>
        <img
          style="height: 20px; margin: 10px"
          src="../../assets/img/exportExcel.png"
          height="50"
        >
      </div>
    </div>
    <ag-grid-vue
      id="myGrid"
      style="width: 100%; height: 500px;"
      class="ag-theme-alpine"
      :grid-options="gridOptions"
      :default-col-def="defaultColDef"
      :column-defs="columnDefs"
      :row-data="rowData"
      @grid-ready="onGridReady"
    />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
export default {

  components: {
    'ag-grid-vue': AgGridVue
  },
  props: {
    selectedFruit: Object
  },
  data: function () {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: []
    }
  },
  beforeMount () {
    this.gridOptions = {}
    this.columnDefs = [
      {
        headerName: 'Frutas y Melones - Productores de etileno',
        children: [
          {
            headerName: `0-2 ${String.fromCharCode(176)}C (32-36 ${String.fromCharCode(176)}F)`,
            field: 'zeroTwo',
            cellRenderer: this.ragRenderer,
            cellClass: this.cellClass
          },
          {
            headerName: `4-7 ${String.fromCharCode(176)}C (40-45 ${String.fromCharCode(176)}F)`,
            field: 'fourSeven',
            cellRenderer: this.ragRenderer,
            cellClass: this.cellClass
          },
          {
            headerName: `7-10 ${String.fromCharCode(176)}C (45-50 ${String.fromCharCode(176)}F)`,
            field: 'sevenTen',
            cellRenderer: this.ragRenderer,
            cellClass: this.cellClass
          },
          {
            headerName: `13-18 ${String.fromCharCode(176)}C (50-65 ${String.fromCharCode(176)}F)`,
            field: 'thirteenEighteen',
            cellRenderer: this.ragRenderer,
            cellClass: this.cellClass
          }
        ]
      }
    ]
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      flex: 1
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
  },
  methods: {
    ragRenderer (params) {
      if (params.value.subtitle) { return '<span>' + params.value.title + ' ' + params.value.subtitle + '</span>' } else if (params.value.title) { return '<span>' + params.value.title + '</span>' }
    },
    cellClass (params) {
      if (params.value.isActive) return 'sick-days-warning'
    },
    async downloadFile () {
      const title = this.columnDefs[0].headerName
      const columns = this.columnDefs[0].children.map(x => x.headerName)
      const rows = []
      const activedTitles = []
      this.rowData.forEach((row) => {
        let zeroTwo = ''
        if (row.zeroTwo.title) zeroTwo = row.zeroTwo.title
        if (row.zeroTwo.subtitle) zeroTwo += ' ' + row.zeroTwo.subtitle

        const currentRow = [
          zeroTwo,
          row.fourSeven.title ?? '',
          row.sevenTen.title ?? '',
          row.thirteenEighteen.title ?? ''
        ]
        rows.push(currentRow)

        if (row.zeroTwo.isActive && zeroTwo !== '') {
          activedTitles.push(zeroTwo)
        }
        if (row.fourSeven.isActive) {
          activedTitles.push(row.fourSeven.title)
        }
        if (row.sevenTen.isActive) {
          activedTitles.push(row.sevenTen.title)
        }
        if (row.thirteenEighteen.isActive) {
          activedTitles.push(row.thirteenEighteen.title)
        }
      })

      await this.$excelPlugin.downloadFile(columns, rows, title, `${title}.xlsx`, null, (row) => {
        row.eachCell((cell, number) => {
          let color = null
          if (activedTitles.findIndex(x => x === cell.value) > -1) {
            color = 'FFCD853F'
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color }
          }
        })
      })
    },
    onGridReady (params) {
      const data = [
        {
          zeroTwo: { id: 1, title: 'Manzana 1,3,9', subtitle: 'Plum', isActive: false },
          fourSeven: { id: 2, title: 'Durian', isActive: false },
          sevenTen: { id: 3, title: 'Aguacate no maduro', isActive: false },
          thirteenEighteen: { id: 4, title: 'Attemoya', isActive: false }
        },
        {
          zeroTwo: { id: 5, title: 'Durazno', subtitle: 'Prune', isActive: false },
          fourSeven: { id: 6, title: 'Feijoa', isActive: false },
          sevenTen: { id: 7, title: 'Melon crenshaw', isActive: false },
          thirteenEighteen: { id: 8, title: 'Banana', isActive: false }
        },

        {
          zeroTwo: { id: 9, title: 'Aguacate Maduro', subtitle: 'Quince', isActive: false },
          fourSeven: { id: 10, title: 'Guaba', isActive: false },
          sevenTen: { id: 11, title: 'Chirimoya', isActive: false },
          thirteenEighteen: { id: 11, title: 'Chirimoya', isActive: false }
        },
        {
          zeroTwo: { id: 12, title: 'Melon Cantalo upe', subtitle: null, isActive: false },
          fourSeven: { id: 13, title: 'Melon Honey', isActive: false },
          sevenTen: { id: 14, title: 'Maracuya', isActive: false },
          thirteenEighteen: { id: 15, title: 'Jackfrui', isActive: false }
        },
        {
          zeroTwo: { id: 16, title: 'Frutas cortadas', subtitle: null, isActive: false },
          fourSeven: { id: 17, title: 'Melon Persa', isActive: false },
          sevenTen: { id: 18, title: null, isActive: false },
          thirteenEighteen: { id: 19, title: 'Mamey', isActive: false }
        },
        {
          zeroTwo: { id: 20, title: 'Fi 1,7,8', isActive: false },
          fourSeven: { id: 21, title: null, isActive: false },
          sevenTen: { id: 22, title: null, isActive: false },
          thirteenEighteen: { id: 23, title: 'Mango', isActive: false }
        },
        {
          zeroTwo: { id: 24, title: 'Kiwi', isActive: false },
          fourSeven: { id: 25, title: null, isActive: false },
          sevenTen: { id: 26, title: null, isActive: false },
          thirteenEighteen: { id: 27, title: 'Mangosteen', isActive: false }
        },
        {
          zeroTwo: { id: 28, title: 'Nectarina', isActive: false },
          fourSeven: { id: 29, title: null, isActive: false },
          sevenTen: { id: 30, title: null, isActive: false },
          thirteenEighteen: { id: 31, title: 'Papaya', isActive: false }
        },
        {
          zeroTwo: { id: 32, title: 'Pera', isActive: false },
          fourSeven: { id: 33, title: null, isActive: false },
          sevenTen: { id: 34, title: null, isActive: false },
          thirteenEighteen: { id: 35, title: 'Platano', isActive: false }
        },
        {
          zeroTwo: { id: 36, title: 'Pera asiatica', isActive: false },
          fourSeven: { id: 37, title: null, isActive: false },
          sevenTen: { id: 38, title: null, isActive: false },
          thirteenEighteen: { id: 39, title: 'Rambutan', isActive: false }
        },
        {
          zeroTwo: { id: 40, title: 'Pera europea', isActive: false },
          fourSeven: { id: 41, title: null, isActive: false },
          sevenTen: { id: 42, title: null, isActive: false },
          thirteenEighteen: { id: 43, title: 'Zapote', isActive: false }
        },
        {
          zeroTwo: { id: 44, title: null, isActive: false },
          fourSeven: { id: 45, title: null, isActive: false },
          sevenTen: { id: 46, title: null, isActive: false },
          thirteenEighteen: { id: 47, title: 'Toronja', isActive: false }
        }

      ]
      const id = this.$store.state.product.id

      data.forEach((item) => {
        if (item.zeroTwo.id === id) item.zeroTwo.isActive = true
        if (item.fourSeven.id === id) item.fourSeven.isActive = true
        if (item.sevenTen.id === id) item.sevenTen.isActive = true
        if (item.thirteenEighteen.id === id) item.thirteenEighteen.isActive = true
      })
      this.rowData = data
    }
  }
}
</script>
<style  scoped>

.sick-days-warning {
  background-color: sandybrown !important;
}

.sick-days-breach {
  background-color: lightcoral !important;
}
</style>
